import { Navigate, Route } from "react-router-dom";

import { BASE_ROUTE, PortalRoutesWrapper, ROUTES } from "@/app/router";
import { usePortalUserStore } from "@/app/stores";
import type { DomainRoute } from "@/config/paths";
import {
  ConsultationFollowUpForm,
  ConsultationPurpose,
  Consultations,
  ConsultationSchedule,
} from "./screens";

const getPartialRoute = (route: DomainRoute) => {
  return route.replace(BASE_ROUTE.CONSULTATIONS, "");
};

export const ConsultationsRouter = () => {
  const canAccessActiveWLFeaturesWithIntakeFormCompleted = usePortalUserStore(
    (state) => state.canAccessActiveWLFeaturesWithIntakeFormCompleted,
  );

  return (
    <PortalRoutesWrapper>
      {canAccessActiveWLFeaturesWithIntakeFormCompleted && (
        <>
          <Route index element={<Consultations />} />
          <Route
            path={getPartialRoute(ROUTES.CONSULTATIONS.PURPOSE)}
            element={<ConsultationPurpose />}
          />
          <Route
            path={getPartialRoute(ROUTES.CONSULTATIONS.FOLLOW_UP)}
            element={<ConsultationFollowUpForm />}
          />
        </>
      )}

      <Route
        path={`${getPartialRoute(ROUTES.CONSULTATIONS.SCHEDULE)}/:appointmentId?`}
        element={<ConsultationSchedule />}
      />

      <Route path="*" element={<Navigate to={BASE_ROUTE.CONSULTATIONS} />} />
    </PortalRoutesWrapper>
  );
};
